import { ADD_ENTITIES, CLEAR_ENTITIES, SET_ENT_FETCHING } from "../actions/types";

const initialState = { status: "notFetched", entities: [] };

//Handling Datasources
export const entityReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ENT_FETCHING:
      return { ...state, status: "fetching" };
    case ADD_ENTITIES:
      return { ...state, status: "done", entities: payload };
    case CLEAR_ENTITIES:
      return initialState;
    default:
      return state;
  }
};
